import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import { Transition } from 'react-transition-group';
import OtherClickListener from '../../../../../../../events/OtherClickListener';
import { reDraw } from '../../../../../../../helpers/common';
import { propBool, propFunc, propShape, } from '../../../../../../../helpers/custom-prop-types';
import Hover from '../../../../../../Ui/System/Hover';
const AccountTableOverView = (props) => {
    const { hideOverView, isDisabledAccount, isExpired, item, onClickDisableAccount, onClickEditAccount, overViewState, toggleOverView, } = props;
    const ref = useRef();
    useEffect(() => {
        const index = OtherClickListener.setListener(ref.current, () => {
            hideOverView();
        });
        return () => {
            OtherClickListener.deleteListener(index);
        };
    }, [ref, hideOverView]);
    return (_jsx("div", Object.assign({ ref: ref }, { children: _jsxs("div", Object.assign({ className: 'overview-menu' }, { children: [_jsx(Hover, { children: _jsx("button", Object.assign({ className: 'overview-menu-button', onClick: toggleOverView, type: 'button' }, { children: _jsx("i", { className: 'material-icons md-32 btn-drop more_vert' }) })) }), _jsx(Transition, Object.assign({ in: overViewState, mountOnEnter: true, onEnter: reDraw, onExit: reDraw, timeout: 100, unmountOnExit: true }, { children: (state) => (_jsxs("div", Object.assign({ className: clsx('dropdown-menu', state) }, { children: [_jsx(Hover, { children: _jsx("button", Object.assign({ className: 'link-text', disabled: isDisabledAccount, onClick: onClickDisableAccount, type: 'button', value: item.id }, { children: "\u30A2\u30AB\u30A6\u30F3\u30C8\u505C\u6B62" })) }), _jsx(Hover, { children: _jsx("button", Object.assign({ className: 'link-text', disabled: isDisabledAccount || isExpired, onClick: onClickEditAccount, type: 'button', value: item.id }, { children: "\u30E1\u30F3\u30D0\u30FC\u5909\u66F4" })) })] }))) }))] })) })));
};
AccountTableOverView.propTypes = {
    hideOverView: propFunc().isRequired,
    isDisabledAccount: propBool().isRequired,
    isExpired: propBool().isRequired,
    item: propShape().isRequired,
    onClickDisableAccount: propFunc().isRequired,
    onClickEditAccount: propFunc().isRequired,
    overViewState: propBool().isRequired,
    toggleOverView: propFunc().isRequired,
};
export default AccountTableOverView;
